// extracted by mini-css-extract-plugin
export default {"section":"style_section__rV6qC","secWhite":"style_secWhite__98Tfz"};